
<ng-container *ngIf="errorHighlightList">
    <div *ngFor="let errorItem of errorHighlightList; let index = index"
    class="invalid-field-msg data-wrap text-ellipses"
    [innerHTML]="getErrorHighlightMsg(errorItem)" [title]="errorItem">
</div>
</ng-container>
